export enum Gender {
  MALE = "male",
  FEMALE = "female"
}

export interface UserBase {
  id?: string;
  first_name: string;
  last_name: string;
  birth_date: string;
  birth_time?: string;
  country_of_birth: string;
  city_of_birth: string;
  gender: Gender;
  email?: string;
  password?: string;
  mobile: string;
  confirm_marketing_content: boolean;
  is_admin: boolean;
}

export interface UserCreate extends UserBase {
  password?: string;
}

export interface UserUpdate extends Partial<UserBase> {
  password?: string;
}

export interface UserResponse extends UserBase {
  id: string;
  created_at: string;
  updated_at: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

export interface AdminChangePasswordRequest {
  new_password: string;
} 